var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_289_354)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1 30.75H19.9C17.58 30.75 16.25 29.42 16.25 27.1V15C16.25 14.59 16.59 14.25 17 14.25H35C35.41 14.25 35.75 14.59 35.75 15V27.1C35.75 29.42 34.42 30.75 32.1 30.75ZM17.75 15.75V27.1C17.75 28.59 18.41 29.25 19.9 29.25H32.09C33.58 29.25 34.24 28.59 34.24 27.1V15.75H17.75Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 15.75H16C15.59 15.75 15.25 15.41 15.25 15C15.25 14.59 15.59 14.25 16 14.25H36C36.41 14.25 36.75 14.59 36.75 15C36.75 15.41 36.41 15.75 36 15.75Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 35.75C21.7203 35.75 21.4603 35.6 21.3303 35.34C21.1403 34.97 21.2903 34.52 21.6703 34.33L25.2503 32.54V30C25.2503 29.59 25.5903 29.25 26.0003 29.25C26.4103 29.25 26.7503 29.59 26.7503 30V33C26.7503 33.28 26.5903 33.54 26.3303 33.67L22.3303 35.67C22.2303 35.72 22.1103 35.75 22.0003 35.75Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 35.7499C29.8899 35.7499 29.77 35.7199 29.67 35.6699L25.67 33.6699C25.3 33.4799 25.1499 33.0299 25.3299 32.6599C25.5199 32.2899 25.9699 32.1399 26.3399 32.3199L30.3399 34.3199C30.7099 34.5099 30.8599 34.9599 30.6799 35.3299C30.5399 35.5999 30.2699 35.7499 29.9999 35.7499Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4999 24.7499C21.2899 24.7499 21.0699 24.6599 20.9199 24.4799C20.6499 24.1599 20.6999 23.6899 21.0199 23.4199L24.1699 20.7899C24.4599 20.5499 24.8299 20.4499 25.1799 20.5099C25.5399 20.5699 25.8499 20.7899 26.0399 21.1099L27.0899 22.8599L30.0199 20.4199C30.3399 20.1599 30.8099 20.1999 31.0799 20.5199C31.3499 20.8399 31.2999 21.3099 30.9799 21.5799L27.8299 24.2099C27.5399 24.4499 27.1699 24.5499 26.8199 24.4899C26.4599 24.4299 26.1499 24.2099 25.9599 23.8899L24.9099 22.1399L21.9799 24.5799C21.8399 24.6899 21.6699 24.7499 21.4999 24.7499Z",
    fill: "#101828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_289_354",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_289_354"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_289_354",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.6f26eb73a7f4e9893c63a5b8e0eedae1.svg";
export { ForwardRef as ReactComponent };